import { render, staticRenderFns } from "./tutor.vue?vue&type=template&id=4c1bcfbe&scoped=true&"
import script from "./tutor.vue?vue&type=script&lang=js&"
export * from "./tutor.vue?vue&type=script&lang=js&"
import style0 from "./tutor.vue?vue&type=style&index=0&id=4c1bcfbe&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1bcfbe",
  null
  
)

export default component.exports